import axios from '../utils/axios';

const Stocks = {
    getStockData: async () => axios.get('/stocks'),
    getIsMarketForcefullyClosed: async () =>
        axios.get('/stocks/is-market-closed')
};

export default Stocks;
